import { render, staticRenderFns } from "./PublicQuotationPages16.vue?vue&type=template&id=106de2e5&scoped=true&"
import script from "./PublicQuotationPages16.vue?vue&type=script&lang=js&"
export * from "./PublicQuotationPages16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106de2e5",
  null
  
)

export default component.exports